import { relations } from 'drizzle-orm/relations';
import * as schema from './schema';

export const categoryRelation = relations(schema.category, ({ many, one }) => ({
  categoryI18Ns: many(schema.categoryI18N),
  parentCategory: one(schema.category, {
    fields: [schema.category.parentCategoryId],
    references: [schema.category.categoryId],
  }),
}));

export const categoryI18NRelation = relations(schema.categoryI18N, ({ one }) => ({
  category: one(schema.category, {
    fields: [schema.categoryI18N.categoryId],
    references: [schema.category.categoryId],
  }),
}));

export const colorRelation = relations(schema.color, ({ many }) => ({
  itemColors: many(schema.itemColor),
}));

export const emailRelation = relations(schema.email, ({ many }) => ({
  emailSubscribedArrivalNotifications: many(schema.emailSubscribedArrivalNotification),
}));

export const emailSubscribedArrivalNotificationRelation = relations(schema.emailSubscribedArrivalNotification, ({ one }) => ({
  email: one(schema.email, {
    fields: [schema.emailSubscribedArrivalNotification.emailId],
    references: [schema.email.emailId],
  }),
  item: one(schema.item, {
    fields: [schema.emailSubscribedArrivalNotification.itemId],
    references: [schema.item.itemId],
  }),
}));

export const eventRelation = relations(schema.event, ({ one }) => ({
  promoter: one(schema.member, {
    fields: [schema.event.promoterId],
    references: [schema.member.memberId],
  }),
}));

export const featureShopRelation = relations(schema.featureShop, ({ one }) => ({
  seller: one(schema.member, {
    fields: [schema.featureShop.shopId],
    references: [schema.member.memberId],
  }),
  shop: one(schema.shop, {
    fields: [schema.featureShop.shopId],
    references: [schema.shop.shopId],
  }),
}));

export const itemColorRelation = relations(schema.itemColor, ({ one }) => ({
  color: one(schema.color, {
    fields: [schema.itemColor.colorId],
    references: [schema.color.colorId],
  }),
  item: one(schema.item, {
    fields: [schema.itemColor.itemId],
    references: [schema.item.itemId],
  }),
}));

export const itemRelation = relations(schema.item, ({ many, one }) => ({
  itemColor: one(schema.itemColor, {
    fields: [schema.item.itemId],
    references: [schema.itemColor.itemId],
  }),
  itemI18Ns: many(schema.itemI18N),
  itemListingFirstLastHistory: one(schema.itemListingFirstLastHistory, {
    fields: [schema.item.itemId],
    references: [schema.itemListingFirstLastHistory.itemId],
  }),
  itemMaterial: one(schema.itemMaterial, {
    fields: [schema.item.itemId],
    references: [schema.itemMaterial.itemId],
  }),
  itemMetas: many(schema.itemMeta),
  itemOfShopArtist: one(schema.itemOfShopArtist, {
    fields: [schema.item.itemId],
    references: [schema.itemOfShopArtist.itemId],
  }),
  itemOptionOfItems: many(schema.itemOptionOfItem),
  itemPictures: many(schema.itemPicture),
  likenessItems: many(schema.likenessItem),
  likes: many(schema.likeness),
  seller: one(schema.member, {
    fields: [schema.item.shopId],
    references: [schema.member.memberId],
  }),
  shop: one(schema.shop, {
    fields: [schema.item.shopId],
    references: [schema.shop.shopId],
  }),
  tagOfItems: many(schema.tagOfItem),
}));

export const itemI18NRelation = relations(schema.itemI18N, ({ one }) => ({
  item: one(schema.item, {
    fields: [schema.itemI18N.itemId],
    references: [schema.item.itemId],
  }),
}));

export const itemMaterialRelation = relations(schema.itemMaterial, ({ one }) => ({
  material: one(schema.material, {
    fields: [schema.itemMaterial.materialId],
    references: [schema.material.materialId],
  }),
  item: one(schema.item, {
    fields: [schema.itemMaterial.itemId],
    references: [schema.item.itemId],
  }),
}));

export const itemMetaRelation = relations(schema.itemMeta, ({ one }) => ({
  item: one(schema.item, {
    fields: [schema.itemMeta.itemId],
    references: [schema.item.itemId],
  }),
}));

export const itemOfShopArtistRelation = relations(schema.itemOfShopArtist, ({ one }) => ({
  item: one(schema.item, {
    fields: [schema.itemOfShopArtist.itemId],
    references: [schema.item.itemId],
  }),
  shopArtist: one(schema.shopArtist, {
    fields: [schema.itemOfShopArtist.shopArtistId],
    references: [schema.shopArtist.shopArtistId],
  }),
}));

export const itemOptionOfItemRelations = relations(schema.itemOptionOfItem, ({ one }) => ({
  item: one(schema.item, {
    fields: [schema.itemOptionOfItem.itemId],
    references: [schema.item.itemId],
  }),
  itemOption: one(schema.itemOption, {
    fields: [schema.itemOptionOfItem.itemOptionSlug],
    references: [schema.itemOption.itemOptionSlug],
  }),
}));

export const itemOptionRelations = relations(schema.itemOption, ({ many }) => ({
  itemOptionOfItems: many(schema.itemOptionOfItem),
  itemOptionVariants: many(schema.itemOptionVariant),
}));

export const itemOptionVariantRelations = relations(schema.itemOptionVariant, ({ one }) => ({
  itemOption: one(schema.itemOption, {
    fields: [schema.itemOptionVariant.itemOptionSlug],
    references: [schema.itemOption.itemOptionSlug],
  }),
}));

export const itemPictureRelation = relations(schema.itemPicture, ({ one }) => ({
  item: one(schema.item, {
    fields: [schema.itemPicture.itemId],
    references: [schema.item.itemId],
  }),
}));

export const itemViewHistoryRelation = relations(schema.itemViewHistory, ({ one }) => ({
  item: one(schema.item, {
    fields: [schema.itemViewHistory.itemId],
    references: [schema.item.itemId],
  }),
  member: one(schema.member, {
    fields: [schema.itemViewHistory.memberId],
    references: [schema.member.memberId],
  }),
}));

export const likenessItemRelation = relations(schema.likenessItem, ({ one }) => ({
  item: one(schema.item, {
    fields: [schema.likenessItem.itemId],
    references: [schema.item.itemId],
  }),
}));

export const likenssRelation = relations(schema.likeness, ({ one }) => ({
  item: one(schema.item, {
    fields: [schema.likeness.linkId],
    references: [schema.item.itemId],
  }),
  followee: one(schema.member, {
    fields: [schema.likeness.linkId],
    references: [schema.member.memberId],
    relationName: 'followee',
  }),
  member: one(schema.member, {
    fields: [schema.likeness.memberId],
    references: [schema.member.memberId],
    relationName: 'member',
  }),
}));

export const materialI18NRelation = relations(schema.materialI18N, ({ one }) => ({
  material: one(schema.material, {
    fields: [schema.materialI18N.materialId],
    references: [schema.material.materialId],
  }),
}));

export const materialRelation = relations(schema.material, ({ many }) => ({
  itemMaterials: many(schema.itemMaterial),
  materialI18Ns: many(schema.materialI18N),
}));

export const memberRelation = relations(schema.member, ({ many, one }) => ({
  events: many(schema.event),
  memberI18Ns: many(schema.memberI18N),
  memberPicture: one(schema.memberPicture, {
    fields: [schema.member.memberId],
    references: [schema.memberPicture.memberId],
  }),
  follows: many(schema.likeness),
  items: many(schema.item),
  itemViewHistories: many(schema.itemViewHistory),
}));

export const memberI18NRelation = relations(schema.memberI18N, ({ one }) => ({
  member: one(schema.member, {
    fields: [schema.memberI18N.memberId],
    references: [schema.member.memberId],
  }),
}));

export const memberPictureRelation = relations(schema.memberPicture, ({ one }) => ({
  member: one(schema.member, {
    fields: [schema.memberPicture.memberId],
    references: [schema.member.memberId],
  }),
}));

export const newsletterSubscriptionRelation = relations(schema.newsletterSubscription, ({ one }) => ({
  email: one(schema.email, {
    fields: [schema.newsletterSubscription.email],
    references: [schema.email.address],
  }),
}));

export const shopArtistRelation = relations(schema.shopArtist, ({ one, many }) => ({
  shop: one(schema.shop, {
    fields: [schema.shopArtist.shopId],
    references: [schema.shop.shopId],
  }),
  itemOfShopArtists: many(schema.itemOfShopArtist),
}));

export const shopRelation = relations(schema.shop, ({ many }) => ({
  items: many(schema.item),
  shopArtists: many(schema.shopArtist),
}));

export const tagOfItemRelation = relations(schema.tagOfItem, ({ one }) => ({
  item: one(schema.item, {
    fields: [schema.tagOfItem.itemId],
    references: [schema.item.itemId],
  }),
  tag: one(schema.tag, {
    fields: [schema.tagOfItem.tagId],
    references: [schema.tag.tagId],
  }),
}));

export const tagRelation = relations(schema.tag, ({ many }) => ({
  tagOfItems: many(schema.tagOfItem),
}));
